import { Flex, Heading, Text } from "@adobe/react-spectrum";
import { MessageIcon, NoChatIcon, PhoneDisabledIcon } from "../../common/Icons";

interface IActiveCallContainerProps {
  type?: "call" | "callback" | "voicemail" | "chat" | "case";
  title: string;
  description: string;
}

const getIcon = (type?: string) => {
  switch (type) {
    case "chat":
      return <NoChatIcon />;
    case "case":
      return <MessageIcon />;
    default:
      return <PhoneDisabledIcon />;
  }
};

const ActiveCallContainer = ({ type, title, description }: IActiveCallContainerProps) => {
  const containerStyle = title === "Start a new call or wait for the call"
    ? { backgroundColor: "#fff" }
    : undefined;

  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      marginY="size-200"
      UNSAFE_style={containerStyle}
      UNSAFE_className="no-active-call-container"
    >
      {getIcon(type)}
      <Heading UNSAFE_className="no-active-call_Dialer" marginBottom={8}>
        {title}
      </Heading>
      <Text UNSAFE_className="no-active-call_Dialer-desc">
        {description}
      </Text>
    </Flex>
  );
};

export default ActiveCallContainer;
